import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    aboutYou: 'About you',
    confirm: 'Confirm',
    directorDescription: {
      future:
        'You will legally represent the company or have a mandate as Président or Gérant.',
      present:
        'You legally represent the company or have a mandate as Président or Gérant.',
    },
    directorLabel: {
      future: 'Will you be a director of the company?',
      present: 'Are you a director of the company?',
    },
    no: 'No',
    shareholderDescription: 'Shareholder, directly or not.',
    shareholderLabel: {
      future: 'Will you have shares in the company?',
      present: 'Do you have shares in the company?',
    },
    yes: 'Yes',
    you: 'You',
  },
  fr: {
    aboutYou: 'À propos de vous',
    confirm: 'Confirmer',
    directorDescription: {
      future:
        'Représente légalement l’entreprise ou dispose d’un mandat de président ou gérant.',
      present:
        'Représente légalement l’entreprise ou dispose d’un mandat de président ou gérant.',
    },
    directorLabel: {
      future: 'Serez-vous un·e dirigeant·e de l’entreprise\u00A0?',
      present: 'Êtes-vous un·e dirigeant·e de l’entreprise\u00A0?',
    },
    no: 'Non',
    shareholderDescription: 'Actionnaire, directement ou non.',
    shareholderLabel: {
      future: 'Aurez-vous des parts dans l’entreprise\u00A0?',
      present: 'Avez-vous des parts dans l’entreprise\u00A0?',
    },
    yes: 'Oui',
    you: 'Vous',
  },
} as const);
